import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#e2001a',
        secondary: '#8c000a',
        accent: '#fe5359',
        error: '#b71c1c',
      },
    },
    options: { customProperties: true },
  },
});
